import { render, staticRenderFns } from "./GroupImageDropdown.vue?vue&type=template&id=06ba768a"
import script from "./GroupImageDropdown.js?vue&type=script&lang=js&external"
export * from "./GroupImageDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports